<template>
  <!--
        作者：kmdshop
        时间：2019-10-25
        描述：权限-管理员列表-添加管理员
    -->
  <el-dialog title="会员等级" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" :rules="formRules" :label-width="formLabelWidth">
      
      <el-form-item label="选择用户" >
          <div class="d-s-s d-c">
            <el-button @click="openGetuser" icon="el-icon-plus">选择用户</el-button>
            <ul class="d-s-s select-user"  v-if="user.user_id > 0">
              <li class="mr10 d-c-c d-c p-10-0" >
                  <img :src="user.avatarUrl" class="radius" width="30" height="30" />
                  <p class="lh18 ww100 text-ellipsis">{{user.nickName}}</p>
              </li>
              <li class="mr10 d-c-c d-c p-10-0" @click="deleteUser">
                  删除
              </li>
            </ul>
          </div>
        </el-form-item>

      
      
      <el-form-item label="用户名" prop="user_name">
        <el-input v-model="form.user_name" placeholder="请输入用户名">
        </el-input>
      </el-form-item>
      <el-form-item label="所属角色" prop="role_id">
        <el-select v-model="form.role_id" :multiple="true">
          <el-option v-for="item in roleList" :value="item.role_id" :key="item.role_id" :label="item.role_name_h1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="type != 'mobile'" label="登录密码" prop="password"><el-input v-model="form.password" placeholder="请输入登录密码" type="password"></el-input></el-form-item>
      <el-form-item v-if="type != 'mobile'" label="确认密码" prop="confirm_password"><el-input v-model="form.confirm_password" placeholder="请输入确认密码" type="password"></el-input></el-form-item>
      <el-form-item label="姓名" prop="real_name"><el-input v-model="form.real_name"></el-input></el-form-item>
      


             <!--选择用户-->
    <GetUser :is_open="open_getuser"  @close="closeGetuserFunc" :multi="multi"></GetUser>



  
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import AuthApi from '@/api/auth.js';
import GetUser from '@/components/user/GetUser.vue';
export default {
  components:{
    GetUser
  },
  data() {
    return {
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      loading: false,
      /*是否显示*/
      dialogVisible: false,
      /*form表单对象*/
      form: {
        user_name: '',
        access_id: [],
        mobile:""
      },
      multi:false,
      /*form验证*/
      formRules: {
        user_name: [
          {
            required: true,
            message: ' ',
            trigger: 'blur'
          }
        ],
        role_id: [
          {
            required: true,
            message: ' ',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: ' ',
            trigger: 'blur'
          }
        ],
        confirm_password: [
          {
            required: true,
            message: ' ',
            trigger: 'blur'
          }
        ],
        real_name: [
          {
            required: true,
            message: ' ',
            trigger: 'blur'
          }
        ]
      },
      roleList:[],
      user:{
        user_id:0
      },
      open_getuser:false,
    };
  },
  props: ['open','type'],
  watch: {
    open: function(n, o) {
      if (n != o) {
        this.dialogVisible = this.open;
        this.getAllrole();
      }
    }
  },
  created() {
  },
  methods: {
     // 删除用户
     deleteUser(){
      this.user = {user_id:0};
      this.form.mobile = "";
    },
     /*打开获取用户*/
    openGetuser() {
      this.open_getuser = true;
    },

    /*关闭获取用户*/
    closeGetuserFunc(e) {
      if (e.type != 'error') {
        this.user=e.params;
         this.form.mobile = e.params.mobile;
         this.form.user_name = e.params.mobile;
      }
      this.open_getuser = false;
    },
     /*获取角色*/
     getAllrole() {
      let self = this;
      AuthApi.userAddInfo({
        type:self.type
      })
        .then(data => {
          self.roleList = data.data.roleList;
        });
    },
    /*添加*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = self.form;
      params.type = self.type
      AuthApi.userAdd(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，添加成功',
            type: 'success'
          });
          self.dialogFormVisible(true);
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      this.form = {        
        user_name: '',
        access_id: []
     }
      if (e) {
        this.$emit('close', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('close', {
          type: 'error',
          openDialog: false
        });
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/auth/user/dialog/Add.vue